import { Component, OnInit } from '@angular/core';
import { PackageReceiveService } from '../../data-services/package.receive.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { ClientDataService } from '../../data-services/client.service';
import { FormsModule } from '@angular/forms';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { PackageReceiveProgressComponent } from './package.receive.progress';
import { CardModule } from 'primeng/card';

@Component({
   selector: 'package-receive-client',
   templateUrl: './package.receive.client.html',
   styleUrls: ['./step.css'],
   providers: [MessageService],
   imports: [FormsModule, Toast, CommonModule, PackageReceiveProgressComponent, CardModule]
})
export class PackageReceiveClientComponent implements OnInit {

   package: PackageReceiveService;
   showSpinner: boolean = false;

   constructor(private clientDataService: ClientDataService,
      private packageReceiveSvc: PackageReceiveService,
      private router: Router) {
      this.package = packageReceiveSvc;
      this.package.stepnumber = 3;
   }

   ngOnInit() {
      this.package.client = null;

      if (this.package.FromCity) {
         this.doClientAddressSearch();
      }

      if (!this.package.trackingNumber) {
         this.router.navigate(['package-receive-new/package-receive-scan']);
      }
   }

   prevPage() {
      this.router.navigate(['package-receive-new/package-receive-shipper']);
   }

   nextPage() {
     if (!this.package.client) {
       this.router.navigate(['package-receive-new/package-receive-sender']);
     }
     else if (this.package.packageFound) {
         this.router.navigate(['package-receive-new/package-receive-review']);
      } else {
        this.router.navigate(['package-receive-new/package-receive-label']);
      }
   }

  searchByClientAddress() {
      this.router.navigate(['package-receive-new/package-receive-sender']);
   }

   clients: any[];
   clientSearchString: string;
   textSearch: boolean = false;

   public doClientSearch() {
      this.textSearch = true;
      this.clients = [];
      if (this.clientSearchString != null && this.clientSearchString.length > 0) {
         this.clientDataService.searchList(this.clientSearchString).subscribe((data: any) => {
            for (var i = 0; i < data.length; i++) {
               data[i].selected = false;
               data[i].OriginalName = data[i].Name;
               this.clients.push(data[i]);
            }
         });
      }
   }

   public doClientAddressSearch() {
      this.textSearch = false;
      this.clients = [];
      this.clientDataService.searchByLocation(this.package.FromAddress1, this.package.FromCity, this.package.FromState, this.package.FromZipCode).subscribe((data: any) => {
         this.clients = [];
         for (var i = 0; i < data.length; i++) {
            var tmp = data[i].Name + " (" + data[i].DistanceInMiles + " miles)";
            data[i].OriginalName = data[i].Name;
            data[i].Name = tmp;
            data[i].selected = false;
            this.clients.push(data[i]);
         }
      });
   }

   radioChecked(id, i) {
      this.clients.forEach(item => {
         if (item.Id !== id) {
            item.selected = false;
         } else {
           //if (!this.package.FromName) {
             this.package.FromName = item.OriginalName;
           //}

            if (this.package.addressBypassed) {
                this.package.FromAddress1 = item.Address1;
                this.package.FromCity = item.City;
                this.package.FromState = item.State;
                this.package.FromZipCode = item.ZipCode;
            }

            this.package.client = item;
            this.nextPage();
            item.selected = true;
         }
      })
   }
}
